/**
 * JourneyOffIcon/index.js
 * desc: system icon for missing/disabled journey
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const JourneyOffIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="journey-off icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.journeyOff.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M1.585 0L0 1.585l3.652 3.652a11.16 11.16 0 00-2.531 7.091c0 6.187 5.02 11.208 11.207 11.208 2.69 0 5.16-.95 7.092-2.531L22.415 24 24 22.415l-2.995-2.995C21.315 19.041 3.328 1.743 1.585 0zm7.786 10.956l-3.767 8.097 8.097-3.767-4.33-4.33z"/><path d="M19.053 5.604l-2.7 5.802 5.979 5.979a11.154 11.154 0 001.204-5.057c0-6.186-5.021-11.207-11.208-11.207-1.819 0-3.537.434-5.056 1.204l5.978 5.978 5.803-2.7z"/></svg>
    </IconButton>
);


export default JourneyOffIcon;
